import { useTheme } from "@mui/material";
import MUITab, { TabProps } from "@mui/material/Tab";
import MUITabs, { TabsProps } from "@mui/material/Tabs";
import Box from "./Box";

export const Tabs = (props: TabsProps) => {
  const theme = useTheme();
  return (
    <MUITabs
      {...props}
      sx={{
        "&.MuiTabs-root": {
          minHeight: "13px",
        },
      }}
      TabIndicatorProps={{
        sx: {
          height: "1px",
          backgroundColor: theme.palette.primaryBlue.main,
        },
      }}
    />
  );
};

export const Tab = (props: TabProps) => {
  const theme = useTheme();
  const styles = {
    muiTab: {
      fontSize: "13px",
      color: theme.palette.surface70.main,
      textTransform: "none",
      "&.Mui-selected": {
        color: theme.palette.surface80.main,
        fontWeight: theme.typography.fontWeightMedium,
      },
      "&.MuiButtonBase-root": {
        padding: 0,
        minHeight: "21px",
        paddingY: "8px",
        marginRight: theme.spacing(2),
      },
      "&.MuiTab-root": {
        minWidth: "fit-content",
      },
      ".MuiTouchRipple-root": {
        display: "none",
      },
    },
  };
  return <MUITab {...props} sx={styles.muiTab} />;
};

export const TabPanel = ({
  children,
  value,
  index,
  ...props
}: {
  children: JSX.Element | string;
  value: string;
  index: string;
}) => {
  const styles = {
    tabPanel: {
      width: "100%",
    },
  };

  return (
    <Box
      role="tabpanel"
      sx={styles.tabPanel}
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...props}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
};
